<template>
    <div class="veui-header-v2">
        <div class="top-header">
            <div class="top-header-left">
                <div class="cc-header-left" @click="handleBackHome">
                    <img src="../../assets/logo.png" alt="">
                </div>
                <veui-tabs
                    v-if="showTabs"
                    class="top-header-tab"
                    ui="borderless"
                    :active.sync="activeTab"
                    @change="handleTabChange"
                >
                    <template v-for="item in showNavConfig">
                        <template v-if="!item.authorizedRole || checkHagRole(hags, item.authorizedRole)">
                            <veui-tab
                                v-if="item.children"
                                :key="item.value + item.title"
                                :name="item.value"
                                :label="item.title"
                                :disabled="!!item.disabled"
                            >
                                <template #item="{label, active}">
                                    <div
                                        :ref="item.value"
                                        :class="{
                                            'nav-item': true,
                                            'nav-item-actived': active,
                                            'nav-custom-item': true,
                                            [`${item.value}-tab-item`]: true,
                                            'has-children': true,
                                        }"
                                        @mouseenter="handleMouseEnterTab(item)"
                                        @click.stop="handleClickHeaderTab(item)"
                                    >
                                        {{ label }}
                                        <veui-icon
                                            :name="(showCustomTabPopover && hoverTab === item.value)
                                                ? 'chevron-up' : 'chevron-down'
                                            "
                                            class="nav-custom-arrow"
                                        />
                                    </div>
                                </template>
                            </veui-tab>
                            <veui-tab
                                v-else
                                :key="item.value"
                                :label="item.title"
                                :name="item.value"
                                :disabled="!!item.disabled"
                            />
                        </template>
                    </template>
                    <!-- 自定义tab-item，避免tabs都不匹配时，第一个tab也会默认选中态 -->
                    <template #tab-item="{label, activate, active, name}">
                        <span
                            :class="{'nav-item': true, 'nav-item-actived': active && activeTab === name}"
                            @click="activate"
                        >{{ label }}</span>
                    </template>
                </veui-tabs>
            </div>
            <div class="top-header-right">
                <!-- <div
                    v-if="optName && (routeName === 'homeV2Default' || routeName === 'homeV2')"
                    class="top-jump-textcreate-btn"
                    @click="handleJumpToTextCreate"
                >
                    <img
                        class="top-jump-textcreate-btn-img"
                        src="https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/deepseek-jump-text_2x.png"
                    >
                </div> -->
                <div v-show="checkTabVisible(aiButtonConfig)" class="top-header-aifront">
                    <ai-button
                        class="top-aifront-button"
                        variant="ai"
                        size="medium"
                        @click="handleClickAiFront"
                    />
                </div>
                <cc-nav-coupon v-if="optName && checkTabVisible(couponConfig)"/>
                <div v-show="false" class="help-icon">
                    <span @click="gotoHelpDoc">
                        <veui-icon ref="helpRef" name="question-circle"/>
                    </span>
                    <veui-tooltip
                        position="bottom"
                        target="helpRef"
                        ui="reverse"
                        :hide-delay="100"
                        overlay-class="help-overlay"
                    >
                        帮助文档
                    </veui-tooltip>
                </div>
                <feedback/>
                <message-center v-if="optName && !hagOnlyDigital"/>
                <task-center v-if="optName"/>
                <div
                    v-if="hasVideoAgentPermission"
                    class="video-agent-btn"
                    @click="handleVideoAgentClick"
                >
                    视频Agent
                    <veui-icon name="arrow-right"/>
                </div>
                <avatar v-if="optName"/>
                <!-- 隐藏返回旧版的按钮
                <div class="split-line"></div>
                <div
                    v-if="isStyleV2"
                    class="style-version-toggle"
                >
                    <veui-button
                        class="style-version-toggle-btn"
                        ui="m text"
                        @click="handleToggleStyleVersion"
                    >
                        <veui-icon name="arrow-u-up-left"/>返回旧版
                    </veui-button>
                </div>
                -->
            </div>
        </div>
        <veui-popover
            :open.sync="showCustomTabPopover"
            :target="customTabRef"
            trigger="hover"
            :hide-delay="100"
            position="bottom-start"
            :overlay-class="`custom-popover ${hoverTab}`"
        >
            <div
                v-for="(groupItem, groupIndex) in customTabContent"
                :key="`first-group-${groupIndex}`"
                class="header-popover-group"
                :class="{
                    'has-group-title': groupItem.title,
                    [`groups-num-${customTabContent.length}`]: true,
                    [`groups-num-wider`]: needWider,
                }"
            >
                <div
                    v-if="groupItem.title"
                    class="header-popover-group-title"
                    @click="handleOpenSummaryPage(groupItem)"
                >
                    <veui-icon v-if="groupItem.icon" :name="groupItem.icon"/>{{ groupItem.title }}
                </div>
                <template v-for="(item, secondIndex) in groupItem.children">
                    <div
                        v-if="!item.isEmpty"
                        :key="`custom-button-${secondIndex}`"
                        :class="{
                            'custom-tab-button': true,
                            // 'custom-tab-button-selected': pageRouteName === item.value,
                            'disabled': item.markType === 'wait',
                        }"
                        @click="handleOpenTabPage(item)"
                    >
                        {{ item.title }}
                        <div
                            v-if="item.markType"
                            :class="`custom-tab-button-mark mark-${item.markType}`"
                        >{{ item.markText }}</div>
                        <div
                            v-else-if="item.markIcon"
                            :class="`custom-tab-button-icon icon-${item.markIcon}`"
                        >
                            <!-- 注意在组件中引用该icon主题 -->
                            <veui-icon :name="item.markIcon"/>
                        </div>
                    </div>
                </template>
            </div>
        </veui-popover>
    </div>
</template>

<script>
/* globals ucCommonLogin */
import {Tabs, Tab, Popover, Icon, Tooltip} from 'veui';
import {applyReactInVue} from 'vuereact-combined';
import {Button as AiButton} from '@baidu/light-ai-react';
import {navConfig} from '../config/configV2';
import {
    checkHagRole,
    checkLimitRole,
    getRedirectUrl,
    logoutUcAndPass,
    checkItemValid,
    getRouteQuery
} from '@/common/util';
import store from '@/store';
import {sendAlsLog} from '@/lib/als.js';
import Feedback from '@/component/Feedback';
import NavCoupon from '@/component/Coupon/NavCoupon';
import MessageCenter from '@/views/Message/MessageCenter';
import Avatar from '@/layouts/Avatar.vue';
import TaskCenter from '@/component/TaskCenter';
import 'veui-theme-dls-icons/user-circle';
import 'veui-theme-dls-icons/chevron-up';
import 'veui-theme-dls-icons/chevron-down';
import 'veui-theme-dls-icons/sign-out';
import 'veui-theme-dls-icons/order';
import 'veui-theme-dls-icons/question-circle';
import 'veui-theme-dls-icons/info-circle';
import 'veui-theme-dls-icons/arrow-right';
import 'veui-theme-dls-icons/arrow-u-up-left';
import 'veui-theme-dls-icons/box-solid';
import 'veui-theme-dls-icons/folder-download-solid';
import 'veui-theme-dls-icons/external-link';
import 'veui-theme-dls-icons/shield-wave-solid';
import 'veui-theme-dls-icons/trend-monitor-solid';

export default {
    name: 'nav-component',
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-popover': Popover,
        // 'veui-button': Button,
        'veui-icon': Icon,
        'veui-tooltip': Tooltip,
        AiButton: applyReactInVue(AiButton),
        Feedback,
        MessageCenter,
        'cc-nav-coupon': NavCoupon,
        TaskCenter,
        Avatar
    },
    inject: ['$toast', '$alert'],
    data() {
        return {
            aiButtonConfig: {
                authorizedRole: 'digital_human_list',
                forbidOuterUser: true, // 不允许外部用户访问
                hideRole: 'digital_is_passport'
            },
            // 免费名单不显示点券
            couponConfig: {
                hideRole: 'generate_not_pay'
            },
            checkHagRole,
            navConfig,
            activeTab: this.$route.matched[0].name || '',
            customTabRef: '',
            hoverTab: '',
            showCustomTabPopover: false,
            customTabContent: [],
            pageRouteName: this.$route.matched[1]?.name || this.$route.matched[0].name || '',
            needWider: false
        };
    },
    computed: {
        optName() {
            return store.state.app.userInfo.accountInfo?.optName || '';
        },
        userName() {
            return store.state.app.userInfo.accountInfo?.userName || '';
        },
        showTabs() {
            // 帮助文档页面不展示导航菜单
            return !(this.$route.name === 'helpDoc');
        },
        routeName() {
            return this.$route.name;
        },
        hags() {
            return store.state.app.userInfo.bizHags;
        },
        isStyleV2() {
            return this.$store.state.app.userInfo.isStyleV2;
        },
        userInfo() {
            return store.state.app.userInfo;
        },
        isUC() {
            return store.state.app.userInfo.isUC;
        },
        hagOnlyDigital() {
            return this.hags.digital_is_passport;
        },
        hasVideoAgentPermission() {
            return this.hags.qingduo_v3_agent_video === true;
        },
        showNavConfig() {
            const {navConfig, checkTabVisible} = this;
            return navConfig.map(item => {
                if (item.children) {
                    let newItem = {
                        ...item,
                        children: item.children.map(second => {
                            // 三级嵌套
                            if (second.children) {
                                // 不在小流量名单内的无权限使用
                                const children = second.children.map(child => {
                                    if (child.limitRole && !checkLimitRole(this.hags, child.limitRole)) {
                                        child.markType = 'wait';
                                        child.markText = '即将上线';
                                        child.routeName = '';
                                        child.value = '';
                                    }
                                    return child;
                                });
                                return {
                                    ...second,
                                    children: children.filter(checkTabVisible)
                                };
                            }
                            return second;
                        }).filter(checkTabVisible)
                    };
                    // 点击跳到第一个子菜单
                    try {
                        let thirdRoute = newItem.children[0].children[0].value;
                        if (thirdRoute && newItem.routeName?.indexOf('home') < 0) {
                            newItem.routeName = thirdRoute;
                        }
                    }
                    catch (e) {
                        // do nothing
                    }
                    return newItem;
                }
                return item;
            }).filter(checkTabVisible);
        },
        curCoupon() {
            return store.state.app.couponInfo?.availablePoints || 0;
        }
    },
    watch: {
        // 从数字人导航里的口播侧导跳到脚本文案页面，顶部应该切换active项
        $route(newVal, oldVal) {
            if (this.showTabs) {
                this.activeTab = this.$route.matched[0].name || '';
                this.pageRouteName = this.$route.matched[1]?.name || this.$route.matched[0].name || '';
            }
            this.showCustomTabPopover = false;
        }
    },
    methods: {
        handleVideoAgentClick() {
            const userid = this.$store.state.app.hairuo?.userid;
            window.open(`/v3/user/${userid}/index`, '_blank');
        },
        // 判断某个导航选项是否能显示
        checkTabVisible(item) {
            const {hags, userInfo} = this;
            return checkItemValid(item, {hags, userInfo});
        },
        // 点击返回旧版的按钮，写一个缓存，返回旧版工作台
        handleToggleStyleVersion() {
            window.sessionStorage.setItem('style_click_old', '1');
            this.alsLog({
                f1: 'newHeaderGotoOld',
                f2: 'click'
            });
            this.$router.push({
                name: 'digitalConsole'
            });
        },
        handleBackHome() {
            this.$router.push({
                name: this.isStyleV2 ? 'homeV2Default' : 'home',
                params: {
                    userid: this.$route.params.userid
                }
            });
        },
        handleTabChange(tab) {
            if (!this.userName) {
                this.login(tab.name);
                return false;
            }
            this.$router.push({
                query: getRouteQuery() || {},
                name: tab.name
            });
        },
        login(pathname) {
            window.location.href = getRedirectUrl(pathname);
            // window.location.href = '/index';
        },
        logoutClick() {
            let pathname = '/login';
            logoutUcAndPass(pathname);
        },
        // 点击头部，如果是多级tab有展开的，配置了路由则tab也可以点击直接跳转
        handleClickHeaderTab(item) {
            if (item.routeName) {
                this.$router.push({
                    name: item.routeName
                });
            }
        },
        handleMouseEnterTab(item) {
            this.customTabRef = this.$refs[item.value];
            this.customTabContent = item.children;
            this.showCustomTabPopover = true;
            this.hoverTab = item.value;
            this.needWider = item.needWider;
        },
        // 点击主题进入相应的聚合页
        handleOpenSummaryPage(groupItem) {
            return false;
            // this.$router.push({
            //     name: groupItem.routeName,
            //     params: {
            //         activeTab: groupItem.name
            //     }
            // });
        },
        handleOpenTabPage(item) {
            if (item.link) {
                const userid = this.$store.state.app.hairuo?.userid;
                let url = item.link;
                if (url.indexOf('${userid}') > -1 && userid) {
                    url = url.replace('${userid}', userid);
                }
                window.open(url, '_blank');
            }
            if (!item.value || this.$route.name === item.value) {
                return;
            }
            this.activeTab = item.value;
            this.$router.push({
                name: item.value,
                params: {
                    beforeJumpName: this.$route.name
                }
            });
        },
        handleClickAiFront() {
            this.$router.push({
                name: 'aiCreateFrontPage'
            });
        },
        handleJumpToTextCreate() {
            this.$router.push({
                name: 'textCreateTitleV2'
            });
        },
        gotoHelpDoc() {
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            const firstDoc = '信息流广告标题';
            const url = `${prefix}/helpDoc/${firstDoc}`;
            this.alsLog({
                f1: 'helpDoc',
                f2: 'click',
                f5: this.$route.name,
                f15: this.$route?.path
            });
            window.open(url, '_blank', 'noreferrer');
        },
        alsLog(data) {
            const userid = this.$store.state.app.hairuo?.userid;
            const optid = this.$store.state.app.hairuo?.optid;
            if (!userid) {
                return false;
            }
            // 如果没有f5，默认把页面路径带上
            if (data.f5 == null) {
                data.f5 = this.$route.name;
            }
            return sendAlsLog({
                ...data,
                f3: userid,
                f14: optid
            });
        }
    }
};
</script>

<style lang="less" scoped>
@content-padding: 24px;

.veui-header-v2 {
    background: transparent;
}

.top-header {
    position: fixed;
    width: 100%;
    height: 64px;
    top: 0;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    &-left {
        display: flex;
    }
    .cc-header-left {
        display: flex;
        align-items: center;
        margin-right: 48px;
        min-width: 146px;
        cursor: pointer;
        img {
            height: 24px;
        }
    }
    /deep/ .veui-tabs-menu {
        height: 36px;
    }
    &-tab {
        display: inline-block;
        padding-top: 22px;
        padding-bottom: 6px;
        .nav-item {
            line-height: 20px;
            // cursor: pointer;
            position: relative;
            &-actived {
                color: #3A5BFD;
                font-weight: 500;
                &:after {
                    content: '';
                    display: block;
                    width: 14px;
                    height: 1px;
                    background-color: #3A5BFD;
                    width: 28px;
                    height: 3px;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    border-radius: 4px;
                }
                &.has-children {
                    &:after {
                        left: 0;
                        transform: translateX(0);
                    }
                }
            }
            &-icon-pay{
                width: 28px;
                height: 14px;
                position: absolute;
                top: -10px;
                font-size: 10px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                border-radius: 4px 4px 4px 0;
                background: var(--AI, linear-gradient(269deg, #9D6DFF 0.05%, #5F82FF 48.58%, #67A4FF 99.95%));
                filter:
                    drop-shadow(0px 2px 24px rgba(0, 84, 230, 0.02))
                    drop-shadow(0px 4px 26px rgba(0, 84, 230, 0.03))
                    drop-shadow(0px 6px 28px rgba(0, 84, 230, 0.04));
            }
            /deep/ .dls-icon {
                vertical-align: -2px;
            }
        }
    }
    &-right {
        display: flex;
        align-items: center;
        gap: 16px;
        .split-line {
            width: 1px;
            height: 16px;
            background: @dls-color-gray-5;
        }
        .style-version-toggle-btn {
            line-height: 20px;
            color: @dls-color-gray-9;
        }
        .video-agent-btn {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 4px 12px;
            gap: 4px;
            width: 112px;
            height: 28px;
            background: linear-gradient(
                97.61deg, #0099E6 2.03%, #3A5BFD 26.99%, #3A5BFD 49.13%, #3A5BFD 66.56%, #794DFF 98.53%
            );
            border-radius: 16px;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #FFFFFF;
            cursor: pointer;
            flex: none;
            flex-grow: 0;
        }
        .top-jump-textcreate-btn {
            cursor: pointer;
            &-img {
                height: 28px;
                width: auto;
                display: block;
            }
        }
    }
    .top-header-aifront {
        & > div {
            display: flex !important;
            height: 100% !important;
        }
        /deep/ .light-ai-button {
            background: transparent;
            height: 24px;
            width: 24px;
            min-height: 24px;
            gap: 0;
            &::before,
            &::after {
                display: none;
            }
            &:hover,
            &:active,
            &:focus {
                background: transparent;
            }
        }
    }
    .nav-custom-item {
        cursor: pointer;
        &:hover {
            color: #3A5BFD;
        }
        .nav-custom-arrow {
            // position: absolute;
            // right: -16px;
        }
        &.assetsLibraryPictrue-tab-item {
            // width: 66px;
            // position: relative;
            // margin-left: -6px;
        }
    }
}
.top-header-tab {
    /deep/ .veui-tabs-menu {
        .veui-tabs-item {
            &.veui-disabled {
                cursor: not-allowed;
                color: rgba(83,98,128,.5);
            }
        }
    }
    /deep/.veui-tabs-item > .veui-tabs-item-label {
        align-items: flex-start;
    }
    /deep/.veui-tabs-item-label-content {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
    }
    /deep/.veui-tabs-item:not(.veui-disabled) > .veui-tabs-item-label::after {
        left: 50%;
        width: 28px;
        height: 3px;
        border-radius: 4px;
        transform: translateX(-50%);
    }
    /deep/.veui-tabs-item-active:not(.veui-disabled) > .veui-tabs-item-label::after {
        background-color: #3A5BFD;
    }
    /deep/.veui-tabs-item:not(.veui-disabled):hover > .veui-tabs-item-label {
        color: #3A5BFD;
    }
    /deep/.veui-tabs-item-active:not(.veui-disabled) > .veui-tabs-item-label {
        color: #3A5BFD;
        font-weight: 500;
    }
    /deep/.veui-tabs-item-label-ellipsis  {
        overflow: visible;
    }
}
// 临时Bug处理：只有一个导航、出现了左右箭头且超出hidden，需要显示定制角标，临时覆盖样式
/deep/ .top-header-tab.veui-tabs-overflow {
    .veui-tabs-list {
        overflow: visible;
    }
    .veui-tabs-menu {
        .veui-tabs-prev,
        .veui-tabs-next {
            display: none;
        }
    }
}
.custom-popover {
    margin-top: -22px;
    &.summaryPage {
        margin-left: -131px;
    }
    /deep/ .veui-tooltip {
        max-width: unset;
        border-radius: 12px;
        box-shadow: 0px 8px 16px 4px #0047C214,
            0px 7px 14px 2px #0047C212,
            0px 1px 8px 0px #0047C20D;
        margin-top: 26px;

        &-content {
            margin: 24px;
            margin-bottom: 10px;
        }
        &-arrow {
            display: none;
        }
    }
    /deep/ .veui-popover-content {
        display: flex;
        flex-direction: row;
        gap: 24px;
        overflow: visible;
        .header-popover-group {
            width: 160px;
            display: flex;
            flex-direction: column;
            &.groups-num-1 {
                width: 80px;
            }
            &.groups-num-2 {
                width: 96px;
            }
            &.groups-num-wider {
                min-width: 108px;
            }
            .header-popover-group-title,
            .custom-tab-button {
                font-size: 14px;
                line-height: 20px;
                display: inline-flex;
                color: @dls-color-gray-9;
                margin-bottom: 14px;
                cursor: pointer;
                width: auto;
                align-items: center;
                position: relative;
                white-space: nowrap;
                &:not(.disabled):not(.header-popover-group-title):hover {
                    color: #3A5BFD;
                    .dls-icon {
                        color: #3A5BFD;
                    }
                }
                &-selected {
                    color: #3A5BFD;
                }
                &.disabled {
                    cursor: not-allowed;
                    color: #545B66;
                }
                &-mark {
                    margin-top: -8px;
                    margin-left: 2px;
                    padding: 2.5px 4px 1.5px 4px;
                    border-radius: 6px 6px 6px 0px;
                    font-size: 12px;
                    line-height: 16px;
                    background: #668BCC1A;
                    color: #545B66;
                    font-weight: 400;
                    &.mark-new {
                        color: #3A5BFD;
                        background: linear-gradient(271.37deg, #F0EBFF -0.08%, #E6FCFF 99.45%);
                        font-weight: 500;
                        min-width: 30px;
                    }
                    &.mark-wait {
                        min-width: 56px;
                    }
                }
                &-icon {
                    width: 16px;
                    height: 16px;
                    font-size: 14px;
                    line-height: 14px;
                    color: @dls-color-gray-7;
                    margin-left: 4px;
                }
            }
            .header-popover-group-title {
                font-weight: 500;
                .dls-icon {
                    width: 16px;
                    min-width: 16px;
                    color: #7A8FB8;
                    margin-right: 8px;
                }
            }
            &.has-group-title {
                .custom-tab-button {
                    padding-left: 24px;
                }
            }
        }
    }
}
.help-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    &:hover {
        color: #545B66;
    }
}
.help-overlay {
    /deep/ .veui-tooltip {
        border-radius: var(--Radius-r1, 6px);
        background: var(----G9, #282C33);
        margin-top: 6px;
        padding: 0 8px;
        height: 25px;
    }
    /deep/ .veui-tooltip-content {
        margin: 0px;
        color: var(----G0, #FFF);
        display: inline-flex;
        height: 100%;
        align-items: center;
    }
    /deep/ .veui-tooltip-arrow {
        color: var(----G9, #282C33);
    }
}
</style>
